import styled from 'styled-components'
import { breakpoint } from 'utils'

import UnstyledBanner from '../Banner'

import background1x from 'modules/workspace/images/diamond@1x.png'
import background2x from 'modules/workspace/images/diamond@2x.png'

export const Banner = styled(UnstyledBanner)`
  background-color: ${({ theme }) => theme.colors.brand.green[100]};
  background-position: right -120px center;

  /* stylelint-disable value-no-vendor-prefix */
  background-image: -webkit-image-set(
    url(${background1x}) 1x,
    url(${background2x}) 2x
  );
  /* stylelint-enable value-no-vendor-prefix */

  background-repeat: no-repeat;

  ${breakpoint('sm')`
    background-position: right -50px center;
  `}
`
